const Loginin = () => {
    return (
        <div className="text-center p-6">
            <h1 className="text-3xl font-bold text-yellow-600">📩 订阅我们的消息</h1>
            <p className="text-gray-700 mt-2">输入你的邮箱，获取最新的煎饼果子优惠信息！</p>
        </div>
    );
};

export default Loginin;